export type AnalysisStage =
  | 'uploading'
  | 'processing'
  | 'telemetry'
  | 'coaching'
  | 'complete';

export interface StageConfig {
  stage: AnalysisStage;
  label: string;
  progressRange: [number, number]; // [start%, end%]
  estimatedSeconds: number;
  statusText: string;
}

export const STAGES: StageConfig[] = [
  {
    stage: 'uploading',
    label: 'Uploading video',
    progressRange: [0, 20],
    estimatedSeconds: 30,
    statusText: 'Uploading video...',
  },
  {
    stage: 'processing',
    label: 'Processing video',
    progressRange: [20, 40],
    estimatedSeconds: 45,
    statusText: 'Processing frames...',
  },
  {
    stage: 'telemetry',
    label: 'Analyzing telemetry',
    progressRange: [40, 70],
    estimatedSeconds: 60,
    statusText: 'Reading swing data...',
  },
  {
    stage: 'coaching',
    label: 'Generating coaching insights',
    progressRange: [70, 95],
    estimatedSeconds: 45,
    statusText: 'Crafting your plan...',
  },
  {
    stage: 'complete',
    label: 'Complete',
    progressRange: [95, 100],
    estimatedSeconds: 5,
    statusText: 'Your swing is ready!',
  },
];

export interface AnalysisStatusResponse {
  swingRunId: string;
  stage: AnalysisStage;
  progress: number; // 0-100
  statusText: string;
  estimatedTimeRemaining?: number; // optional
}

